// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/a5d1118a-4e18abbf46a2cd60.js";
	if (chunkId === 867) return "static/chunks/867-2414440d3493b2cf.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"d742e929ae376f63","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"56b4cf0654b13700","367":"d59d1f9f5b597e36","639":"7e1b22c1eaec6b80","748":"5eea3a078a4864b3"}[chunkId] + ".js";
};